import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ResponseResumenSolicitudDto } from "../interfaces/responseResumenSolicitud";
import { GenerarLiquidacionPrepagoDto } from "../interfaces/generarLiquidacionPrepagoDto";
import { RecalcularLiquidacionPrepago } from "../interfaces/recalcularLiquidacionprepago";
import { ResponseCalculoLiquidacion } from "../interfaces/responseCalculoLiquidacion";
import { CalcularPrepagoRequestInterface } from "../interfaces/calcularPrepagoRequest.interface";
import { RequestGrabarSolicitudDto, RespuestaFormaPagoPrepagoDto, RespuestaMotivosPrepagoDto } from "../models";
import { FormularioDesrecaudacion } from "../interfaces/formularioDesrecaudacion";
import { RecalculoRemesaPrepagoRequest } from "../interfaces/recalculoRemesaPrepagoRequest";
import { ResponseRecalculoRemesaPrepago } from "../interfaces/responseRecalculoRemesaPrepago";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

interface FactorComisionPrepagoResponse {
    result: number;
}

const calcularPrepagoService = async (body: CalcularPrepagoRequestInterface) => {
    const response: Promise<AxiosResponse> = axiosInstance.post(`siscred-api-cartera-total/v1/prepago/calcular-prepago`, body)
    return response;
}

const obtenerFactorComisionService = async (idMutuo: number) => {
    const response: Promise<AxiosResponse<FactorComisionPrepagoResponse>> = axiosInstance.get(`siscred-api-cartera-total/v1/prepago/get-factor-comision-prepago?mutuoId=${idMutuo}`)
    return response;
}

const obtenerMotivosPrepagoSercice = async () => {
    const response: Promise<AxiosResponse<ListResponseDto<RespuestaMotivosPrepagoDto>>> = axiosInstance.get(`siscred-api-transversal/v1/motivoprepago/get-motivos-prepago`)
    return response;
}

const obtenerFormasPagoPrepagoService = async () => {
    const response: Promise<AxiosResponse<ListResponseDto<RespuestaFormaPagoPrepagoDto>>> = axiosInstance.get(`siscred-api-transversal/v1/formapagoprepago/get-formas-pago-prepago`)
    return response;
}

const generarSolicitudLiquidacionPrepago = async (body: RequestGrabarSolicitudDto) => {

    const headers = {
        'X-Hide-Toast': 'true',
        "X-Hide-Loader" : 'true',
    };
    
    try {
        const response: AxiosResponse = await axiosInstance.post(`siscred-api-reportes/v1/prepago/grabar-solicitud`, body, { headers: headers });
        return response;
    } catch (error) {
        throw error;
    }
};


const obtenerResumen = async (mutuoId: number, idSolicitud: number) => {
    const response: Promise<AxiosResponse<ResponseResumenSolicitudDto>> = axiosInstance.get(`siscred-api-cartera-total/v1/prepago/obtener-resumen-solicitud?mutuoId=${mutuoId}&solicitudId=${idSolicitud}`,{});
    return response;    
}

const obtenerResumenDesrecaudacion = async (mutuoId: number, idSolicitud: number) => {
    const response: Promise<AxiosResponse<FormularioDesrecaudacion>> = axiosInstance.get(`siscred-api-cartera-total/v1/prepago/obtener-resumen-desrecaudacion-prepago?mutuoId=${mutuoId}&solicitudId=${idSolicitud}`,{});
    return response;   
}

const subirLiquidacionPrepago = async (solicitud: GenerarLiquidacionPrepagoDto) => {
    const response: Promise<any> = axiosInstance.post("siscred-api-reportes/v1/prepago/liquidar-solicitud", solicitud, 
        {
            headers: {
                'X-Hide-Toast': 'true',
            }
        }
    )
    return response;
}

const generarRemesaPrepago = async (solicitud: GenerarLiquidacionPrepagoDto) => {
    const response: Promise<any> = axiosInstance.post("siscred-api-reportes/v1/prepago/remesar-solicitud", solicitud, 
        {
            headers: {
                'X-Hide-Toast': 'true',
            }
        }
    )
    return response;
}

const recalcularLiquidacion = async (input: RecalcularLiquidacionPrepago) => {
    const response: Promise<AxiosResponse<ResponseCalculoLiquidacion>> = axiosInstance.post("siscred-api-cartera-total/v1/prepago/calcular-prepago", input)
    return response;
}

const recalcularRemesaPrepago = async (input: RecalculoRemesaPrepagoRequest) => {
    const response: Promise<AxiosResponse<ResponseRecalculoRemesaPrepago>> = axiosInstance.post("siscred-api-cartera-total/v1/prepago/recalcular-remesa-prepago", input)
    return response;
}

const recaudarPrepago = async (form: any) => {
    const response: Promise<any> = axiosInstance.post("siscred-api-recaudacion/v1/prepago/recaudar", form)
    return response;
}

const deshacerRecaudacionPrepago = async (form: any) => {
    const response: Promise<any> = axiosInstance.post("siscred-api-recaudacion/v1/prepago/deshacer-recaudacion", form)
    return response;
}

export {
    calcularPrepagoService,
    obtenerFactorComisionService,
    obtenerMotivosPrepagoSercice,
    generarSolicitudLiquidacionPrepago,
    obtenerResumen,
    subirLiquidacionPrepago,
    recalcularLiquidacion,
    obtenerResumenDesrecaudacion,
    obtenerFormasPagoPrepagoService,
    generarRemesaPrepago,
    recaudarPrepago,
    deshacerRecaudacionPrepago,
    recalcularRemesaPrepago
};
